export default __webpack_public_path__ + "static/media/Carrinho de Compra.ff3a727f.svg";